import { gql } from '@apollo/client';

/**
 * Hub 结构关联的仓库与 DSP 选项。
 * warehouses = hub 下结构挂载的子仓库；dsps = warehouseIds 非空时按所选仓库过滤，否则取 hub 下全部子仓库经 warehouse_dsp 关联的 DSP。
 * daily-task 与 SLA 两个 hub 页面共用。
 */
export const GET_HUB_WAREHOUSE_DSP_OPTIONS = gql`
    query GetHubWarehouseDspOptions($hubId: Long!, $warehouseIds: [Long!]) {
        getHubWarehouseDspOptions(hubId: $hubId, warehouseIds: $warehouseIds) {
            warehouses {
                id
                name
            }
            dsps {
                id
                name
            }
        }
    }
`;

export interface HubWarehouseDspOptionsResponse {
    getHubWarehouseDspOptions: {
        warehouses: Array<{
            id: number;
            name: string;
        }>;
        dsps: Array<{
            id: number;
            name: string;
        }>;
    };
}
